'use strict';

var _ = require('lodash');
var urlJoin = require('url-join');
var userEndpointMixin = require('./user-endpoint-mixin');
var { get: sendGet, patch, delete: deleteAccount } = require('./send-action');

function User(options) {
  this._baseUrl = options.baseUrl;
}

User.prototype.get = function(property) {
  property = property || '';
  var uri = urlJoin(this._baseUrl, this._usersUrl, property, '/');
  return sendGet(uri);
};

User.prototype.update = function(userData) {
  var uri = urlJoin(this._baseUrl, this._usersUrl, '/')
  var requestBody = Object.assign({}, userData);
  return patch(uri, requestBody);
};

User.prototype.delete = function(property) {
  property = property || '';
  var uri = urlJoin(this._baseUrl, this._usersUrl, property, '/');
  return deleteAccount(uri);
};

_.assignIn(User.prototype, userEndpointMixin);

module.exports = User;
